'use client'

import UIText from '@components/ui/UIText'
import { LevelType } from '@components/ui/UIText/UITextRoot'
import { Box } from '@mui/joy'
import { articleSizeState } from '@store/articleSize'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import { useRecoilState } from 'recoil'

interface SubTitleProps {
	children: React.ReactNode
}
const SubTitle = ({ children }: SubTitleProps) => {
	const [state] = useRecoilState(articleSizeState)
	const textLevel = `ArticleBody${state.articleSize}` as LevelType
	return (
		<Box pl={pxToRem(14)} borderLeft={`2px solid ${color.colBlack}`}>
			<UIText
				level={textLevel}
				sx={{
					'&': {
						fontWeight: 600,
						whiteSpace: 'pre-wrap',
					},
				}}
			>
				{children}
			</UIText>
		</Box>
	)
}

export default SubTitle
